

const reducer = (state = [], action) => {
    switch(action.type) {
        // case 'ADD_JWT_DATA':
        //   return state.concat([action.data]);
        case 'ADD_JWT_DATA':
        return {
          ...state,
          "jwtToken": action.jwtdata,
          "merchant": action.merchantName,
          "authcode": action.authcodeData,
          "cancelUrl": action.cancelUrl,
          "setAsPrefferdUrl": action.setAsPrefferdUrl
         }
       case 'SESSIONID_RESPONSE':
         return {
           ...state,
           "sessionID": action.sessionID
          }
       case 'PROVISIONING_LIMIT':
          return {
            ...state,
            "provisioningLimitValue": action.provisioningLimitValue
           }
       case 'LOGIN_RESPONSE':
         // return state.concat([action.response], state.linkId = action.linkId);
          return {
            ...state,
            "loginresponse": action.response,
            "linkId": action.response.linkId,
           "last4Digit" : action.last4Digit
           }
        case 'LINKFI_RESPONSE':
           return {
             ...state,
             "linkfiresponse":action.response,
             "selectedCarddigits":action.selectedCarddigits,
              "last4Digit":action.last4Digit
           }
       case 'SENDCODE_RESPONSE':
           return {
             ...state,
             "sendcoderesponse":action.response
           }
       case 'CANCEL_URL':
          return state.concat([action.canceldata]);
       
     default:
          return state;
      }
}

export default reducer


